export default __webpack_public_path__ + "static/media/iner_team.40077c05.png";